import Vue from "vue";
import VueRouter from "vue-router";
import { getToken } from "@/utils/userInfo";

Vue.use(VueRouter);

const routes = [
  {
    path: "/investmentReport",
    component: () => import("@/views/lnvestmentReport/index.vue"),
    name: "investmentReport",
    meta: {
      title: "项目报告",
    },
  },
  {
    path: "/introduction",
    component: () => import("@/views/Introduction/index.vue"),
    name: "introduction",
    meta: {
      title: "介绍",
      nav_top_bool: true,
    },
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
    name: "login",
    meta: {
      title: "登录",
    },
  },
  {
    path: "/register",
    component: () => import("@/views/register/index"),
    hidden: true,
    name: "register",
    meta: {
      title: "注册",
    },
  },
  {
    path: "/payment/success",
    component: () => import("@/views/payment/success"),
    hidden: true,
    name: "paymentSuccess",
    meta: {
      title: "支付成功",
    },
  },
  {
    path: "/qrcodeWei",
    component: () => import("@/views/member/qrcodeWei"),
    hidden: true,
    name: "qrcodeWei",
    meta: {
      title: "微信支付",
    },
  },
  {
    path: "/productDoc",
    component: () => import("@/views/productDoc/index"),
    name: "productDoc",
    meta: {
      title: "产品文档",
    },
  },
  {
    path: "/T1",
    component: () => import("@/views/thinkerModel/index.vue"),
    name: "thinkerModel",
    meta: {
      title: "AI思考模型",
    },
    children: [
      {
        path: "/T1",
        component: () => import("@/views/thinkerModel/T1/index.vue"),
        name: "thinkerModelT1",
        meta: {
          title: "AI思考模型",
        },
      },
      {
        path: "/Q1",
        component: () => import("@/views/thinkerModel/Q1/index.vue"),
        name: "thinkerModelQ1",
        meta: {
          title: "培训老师匹配",
        },
      },
    ],
  },
  {
    path: "/largeScreen",
    component: () => import("@/views/IndustrialScreen/largeScreen/index.vue"),
    name: "largeScreen",
    meta: {
      title: "产业大屏",
    },
  },
  // {
  //   path: "/IndustrialMap",
  //   component: () => import("@/views/IndustrialScreen/IndustrialMap/index.vue"),
  //   name: "IndustrialMap",
  //   meta: {
  //     title: "产业大屏",
  //   },
  // },
  {
    path: "/industrialScreen",
    component: () => import("@/views/IndustrialScreen/index"),
    name: "industrialScreen",
    meta: {
      title: "产业大屏",
    },
    children: [
      {
        path: "/industrialScreenMap",
        component: () => import("@/views/IndustrialScreen/screenMap/index.vue"),
        name: "industrialScreenMapChild",
        meta: {
          title: "产业大屏",
        },
      },
      {
        path: "/industrialScreenCityMap",
        component: () =>
          import("@/views/IndustrialScreen/screeCityMap/index.vue"),
        name: "industrialScreenCityMapChild",
        meta: {
          title: "产业大屏",
        },
      },
    ],
  },
  {
    path: "/enterpriseDetailInfo",
    name: "EnterpriseDetailInfo",
    component: () => import("@/views/enterpriseDetailInfo/index.vue"),
    meta: {
      title: "企业详情",
    },
  },
  {
    path: "/aiSystemAssistant",
    component: () => import("@/views/aiSystemAssistant/index"),
    name: "aiSystemAssistant",
    meta: {
      title: "AI 操作助手",
    },
  },
  {
    path: "/aiSystemAssistant/settings/sub-agents",
    component: () => import("@/views/aiSystemAssistantSettings/index"),
    name: "aiSystemAssistantSubAgents",
    meta: {
      title: "子 Agent 管理",
    },
  },
  {
    path: "/",
    redirect: { name: "regionalAnalysis" },
    component: () => import("@/views/HomeView.vue"),
    name: "home",
    meta: {
      title: "首页",
      nav_top_bool: true,
    },
    children: [
      {
        path: "/",
        component: () => import("@/views/regionalAnalysis/index"),
        name: "regionalAnalysis",
        meta: {
          title: "区域分析",
        },
      },
      {
        path: "/industrialDistribution",
        component: () => import("@/views/IndustrialDistribution/index"),
        name: "industrialDistribution",
        meta: {
          title: "产业招商",
        },
        children: [
          {
            path: "/industrialDistribution",
            component: () =>
              import("@/views/IndustrialDistribution/industry/index"),
            name: "industrialDistributionChild",
            meta: {
              title: "产业招商",
              icon: "el-icon-s-marketing",
            },
          },
          {
            path: "/ranking",
            component: () =>
              import("@/views/IndustrialDistribution/ranking/index"),
            name: "ranking",
            meta: {
              title: "五百强",
              icon: "el-icon-s-data",
            },
          },
          {
            path: "/emigration",
            component: () =>
              import("@/views/IndustrialDistribution/emigration/index"),
            name: "emigration",
            meta: {
              title: "迁出企业",
              icon: "el-icon-s-data",
            },
          },
          {
            path: "/immigration",
            component: () =>
              import("@/views/IndustrialDistribution/immigration/index"),
            name: "immigration",
            meta: {
              title: "迁入企业",
              icon: "el-icon-s-data",
            },
          },
          {
            path: "/leaseExpirationDate",
            component: () =>
              import(
                "@/views/IndustrialDistribution/leaseExpirationDate/index"
              ),
            name: "leaseExpirationDate",
            meta: {
              title: "租金到期企业",
              icon: "el-icon-s-data",
            },
          },
          {
            path: "/buildingDetails",
            component: () => import("@/views/buildingDetails/index"),
            name: "buildingDetails",
            meta: {
              title: "楼宇详情",
              icon: "el-icon-s-data",
            },
          },
        ],
      },
      {
        path: "/dataCollection",
        component: () => import("@/views/DataCollection/index"),
        name: "dataCollection",
        meta: {
          title: "数据采集",
        },
      },
      {
        path: "/enterprisePhone",
        component: () => import("@/views/enterprisePhone/index"),
        name: "enterprisePhone",
        meta: {
          title: "企业电话",
        },
      },
      {
        path: "/enterpriseInvestment",
        component: () => import("@/views/enterpriseInvestment/index"),
        name: "enterpriseInvestment",
        meta: {
          title: "企业投资",
        },
        children: [
          {
            path: "/enterpriseInvestment",
            component: () =>
              import("@/views/enterpriseInvestment/aiModel/index"),
            name: "enterpriseInvestmentChild",
            meta: {
              title: "AI模型-投资(实时优先)",
              icon: "el-icon-s-data",
            },
          },
          {
            path: "/bigData",
            component: () =>
              import("@/views/enterpriseInvestment/bigData/index"),
            name: "bigData",
            meta: {
              title: "大数据-投资(数据延迟)",
              icon: "el-icon-s-grid",
            },
          },
          // {
          //   path: "/IndustrialMap",
          //   component: () =>
          //     import("@/views/IndustrialScreen/IndustrialMap/index.vue"),
          //   name: "IndustrialMapChild",
          //   meta: {
          //     title: "产业大屏",
          //     icon: "el-icon-s-data",
          //   },
          // },
        ],
      },
      {
        path: "/ownData",
        component: () => import("@/views/ownData/index"),
        name: "ownData",
        meta: {
          title: "自有数据",
        },
      },
      {
        path: "/industrialChain",
        component: () => import("@/views/IndustrialChain/index"),
        name: "industrialChain",
        meta: {
          title: "产业链拆解",
        },
      },
      {
        path: "/batchAiAnalysis",
        component: () =>
          import("@/views/enterpriseInvestment/batchAiAnalysis/index"),
        name: "batchAiAnalysis",
        meta: {
          title: "企业批量AI分析",
          icon: "el-icon-s-data",
        },
      },
      {
        path: "/parkFile",
        component: () => import("@/views/parkFile/ParkArea/index"),
        name: "parkFileChild",
        meta: {
          title: "园区文件",
          icon: "el-icon-s-order",
        },
      },
      {
        path: "/fileUpload",
        component: () => import("@/views/parkFile/upload/index"),
        name: "fileUpload",
        meta: {
          title: "上传文件",
          icon: "el-icon-upload",
        },
      },
    ],
  },

  {
    path: "/userInfo",
    component: () => import("@/views/userInfo/index"),
    name: "userInfo",
    meta: {
      title: "用户信息",
    },
    children: [
      {
        path: "/userInfo",
        component: () => import("@/views/userInfo/proFile/index"),
        name: "userInfoProfile",
      },
      {
        path: "/avatar",
        component: () => import("@/views/userInfo/avatar/index"),
        name: "userInfoAvatar",
      },
      {
        path: "/password",
        component: () => import("@/views/userInfo/password/index"),
        name: "userInfoPassword",
      },
      {
        path: "/phone",
        component: () => import("@/views/userInfo/phone/index"),
        name: "userInfoPhone",
      },
      {
        path: "/login-records",
        component: () => import("@/views/userInfo/loginRecord/index"),
        name: "userInfoLoginRecord",
      },
      {
        path: "/orders",
        component: () => import("@/views/userInfo/order/index"),
        name: "orders",
        meta: {
          title: "订单管理",
        },
      },
      {
        path: "/coins",
        component: () => import("@/views/userInfo/cloudCoin/index"),
        name: "cloudCoinRecord",
        meta: {
          title: "云币记录",
        },
      },
      {
        path: "/feedback",
        component: () => import("@/views/userInfo/feedback/index"),
        name: "feedback",
        meta: {
          title: "反馈中心",
        },
      },
      {
        path: "/verification",
        component: () => import("@/views/userInfo/verification/index"),
        name: "verification",
        meta: {
          title: "云币核销兑换",
        },
      },
      {
        path: "/aiChatMessageHistory",
        component: () => import("@/views/aiChatMessageHistory/index"),
        name: "aiChatMessageHistory",
        meta: {
          title: "分析历史记录",
        },
      },
      {
        path: "/enterpriseFavorite",
        component: () => import("@/views/enterpriseFavorite/index"),
        name: "enterpriseFavorite",
        meta: {
          title: "企业收藏",
        },
      },
    ],
  },
  {
    path: "/member",
    component: () => import("@/views/member/index"),
    name: "member",
    meta: {
      title: "会员中心",
    },
    children: [
      {
        path: "/member/shanhe",
        component: () => import("@/views/member/shanhe/index"),
        name: "memberShanhe",
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

const publicPaths = [
  "/introduction",
  "/login",
  "/register",
  "/payment/success",
  "/qrcodeWei",
  "/productDoc",
];

router.beforeEach((to, from, next) => {
  if (publicPaths.includes(to.path) || getToken()) {
    next();
    return;
  }

  next({
    path: "/introduction",
    query: {
      redirect: to.fullPath || "/",
    },
  });
});

export default router;
